import styled from 'styled-components';
import { SmallIconButtonState } from '.';

interface BaseProps {
	state: SmallIconButtonState;
	isMobile?: boolean;
}

export const Base = styled.div<BaseProps>`
	display: flex;
	padding-top: 2px;
	width: ${(p) => (p.isMobile ? '44px' : '24px')};
	height: ${(p) => (p.isMobile ? '44px' : '24px')};
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.gray[0]};
	&:hover {
		background: ${({ state, theme }) =>
			state === SmallIconButtonState.DISABLED ? 'transparent' : theme.gray[200]};
	}
	border-radius: ${(p) => (p.isMobile ? '22px' : '12px')};
`;

export const Icon = styled.div`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
`;
